import { Alert, Col, Container, Row } from "react-bootstrap";

export function checkDayAndHour(){
    let date = new Date();
    let hours = date.getUTCHours()-6;
    if (hours<0) hours = 24+hours;

    let day = date.getUTCDay();
    return true;
    if ((hours+6)>=24) day = day -1;
    if (day === -1 ) day=6;

    if (day>=1 && day<=5){
        if (day===5){
            if ((hours<7)||(hours>=12)){
                return false;
            }else{
                return true;
            }
        }else{
            if ((hours<7)||(hours>=17)){
                return false;
            }else{
                return true;
            }
        }
    }else{
        return false;
    }

    return false;

}

export function getBadHourAndDayMessage(){
    return <div>
      
                <Container>
                        <Row className="justify-content-center align-items-center">
                            <Col xs={12}>
                            
                            
                                <div className="mb-3 mt-md-4">
                                    <h2 className="fw-bold mb-2  ">Portal de Ingreso de obligaciones de pago</h2>

                                    <div className="mb-3 text-centered">
                                    <Alert variant="danger">El horario de atención del portal es de Lunes a Jueves de 7:00 a 17:00 horas. <br />
                                        Día Viernes: de 7:00 a 12:00 horas. <br />Gracias por su comprensión.</Alert>
                                    </div>
                                </div>
                    
                            </Col>
                        </Row>
                        
                        </Container>
    </div>;
}